module.exports = __webpack_public_path__ + "img/emplate.c7cf17a5.png";